import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  chatCredentialsSelectors,
  markersSelectors,
  setChatSectionPage,
  setMsgInputForBlogSharing,
  setCloseAllDrawers,
  sharePost,
  showCurrentChatFriendMarkerCoordinate,
  usersSelectors
} from 'store'
import { ImagesPng } from 'assets/images'
import {
  getDirectRooms,
  checkIfHasRecoveryKey,
  checkIfNeedsRecoveryKeyInput
} from 'store/chat/services'
import { getMatrixClient } from 'components/Messenger/Matrix/clientStore'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import {
  Avatar,
  Box,
  Button,
  IconButton,
  Input,
  Stack,
  Text
} from '@chakra-ui/react'
import {
  ArrowIcon,
  CopyIcon,
  SendIcon,
  SettingsIcon
} from 'assets/icons'
import {
  isAuth,
  getProfileIdFromMatrixId
} from 'utils/helpers'
import { COLORS } from 'utils/styles'
import {
  REJECTED,
  SUCCEEDED
} from 'utils/constants'

import { MessengerChatUI } from '../chatuiv2'
import { ChatRoom } from '../chatuiv2/ChatRoom'
import { Settings } from '../chatuiv2/Settings'

const MotionBox = motion(Box)

export const Panels = ({
  closeMessenger,
  hidePanelAnimation,
  runClosingAnimation,
  runHidePanel,
  shareText,
  sendBtnClicked,
  setSendBtnClicked
}) => {
  const dispatch = useDispatch()
  const [copyBtnClicked, setCopyBtnClicked] = useState(false)
  const [msgInput, setMsgInput] = useState('')
  const [openRoomId, setOpenRoomId] = useState('')
  const [page, setPage] = useState('contacts')
  let touchStart
  let touchEnd

  const {
    activeProfile,
    user,
    userProfile,
    blogLinkToBeCopied,
    chosenFriends,
    sharingToFriends,
    chatSectionPage
  } = useSelector(usersSelectors)
  const {
    checkIfHasRecoveryKeyStatus,
    hasRecoveryKey,
    needsToInputRecoveryKey,
    syncState,
    directRoomList
  } = useSelector(chatCredentialsSelectors)
  const { markers } = useSelector(markersSelectors)

  const headerTitle = (pageName) => {
    if (pageName === 'settings') {
      return 'Settings'
    }

    if (sharingToFriends) {
      return 'Share'
    }

    if (pageName.startsWith('chat-room-')) {
      if (page === 'contacts') {
        const openedRoom = directRoomList.find((r) => r?.roomId === openRoomId)
        return openedRoom?.name
      }

      if (page === 'groups') {
        //
      }
    }

    return 'Communications'
  }

  const goToMarker = (profileId) => {
    const foundMarker = markers.find((m) => m?.id === profileId)
    if (foundMarker) {
      dispatch(setChatSectionPage('clear'))

      setTimeout(() => {
        dispatch(showCurrentChatFriendMarkerCoordinate({
          coord: foundMarker?.coordinates,
          isStatic: true
        }))

        sessionStorage.setItem('openProfileAfterAnimation', foundMarker?.id)
      }, 850)
    }

    const ownMarker = userProfile.find((up) => up?.id === profileId)
    if (!foundMarker && ownMarker) {
      dispatch(setChatSectionPage('clear'))

      setTimeout(() => {
        dispatch(showCurrentChatFriendMarkerCoordinate({
          coord: ownMarker?.coordinates,
          isStatic: true
        }))

        sessionStorage.setItem('openProfileAfterAnimation', ownMarker?.id)
      }, 850)
    }
  }

  const handleDirectChatAvatar = () => {
    if (page === 'contacts') {
      const openedRoom = directRoomList.find((r) => r?.roomId === openRoomId)

      return openedRoom?.avatarUrl ?? ImagesPng.ProfileImage
    }

    if (page === 'groups') {
      //
    }

    return ''
  }

  const updateShareCount = () => {
    dispatch(sharePost(blogLinkToBeCopied.split('/?post-id=')[1]))
  }

  const closeChatPanel = () => {
    if (chatSectionPage.length > 1) {
      dispatch(setChatSectionPage(null))
    } else {
      closeMessenger({ showParamIds: true })
    }
  }

  const handleReminderMsg = () => {
    if (needsToInputRecoveryKey) {
      return (
        <Text>
          Kindly verify your
          <b> recovery key </b>
          by clicking here
        </Text>
      )
    }

    if (!hasRecoveryKey) {
      return (
        <Text>
          Kindly get your
          <b> recovery key </b>
          by clicking here
        </Text>
      )
    }

    return ''
  }

  const whatToShow = (pageName) => {
    if (pageName === 'settings') {
      return <Settings />
    }

    if (
      pageName.startsWith('chat-room-')
      && openRoomId
    ) {
      return (
        <ChatRoom
          goToMarker={goToMarker}
          roomId={openRoomId}
        />
      )
    }

    if (!user) {
      return (
        <Stack
          margin="16px 0"
          gap="16px 0"
        >
          <Text
            textAlign="center"
            backgroundColor="rgb(229, 229, 229)"
            borderRadius="3px"
            border="solid 1px black"
            padding="10px"
            margin="0 2% !important"
            fontSize="13px"
          >
            Create an account to chat with other users
          </Text>
        </Stack>
      )
    }

    if (
      userProfile
      && !userProfile.find((profile) => profile.is_active)
    ) {
      return (
        <Stack
          margin="16px 0"
          gap="16px 0"
        >
          <Text
            textAlign="center"
            backgroundColor="rgb(229, 229, 229)"
            borderRadius="3px"
            border="solid 1px black"
            padding="10px"
            margin="0 2% !important"
            fontSize="13px"
          >
            Create a profile to chat with other users
          </Text>
        </Stack>
      )
    }

    return (
      <MessengerChatUI
        directRooms={directRoomList}
        page={page}
        setOpenRoomId={setOpenRoomId}
        setPage={setPage}
      />
    )
  }

  const animateVariants = {
    initial: { x: 500 },
    animate: {
      x: runHidePanel || runClosingAnimation ? 500 : 0,
      transition: {
        type: hidePanelAnimation || runClosingAnimation ? 'tween' : 'spring',
        duration: 0.8
      }
    },
    exit: {
      x: 500,
      transition: {
        type: 'tween',
        duration: 0.8
      }
    }
  }

  useEffect(() => {
    if (syncState === 'SYNCING') {
      dispatch(getDirectRooms())
      dispatch(checkIfHasRecoveryKey())
      dispatch(checkIfNeedsRecoveryKeyInput())
    }
  }, [syncState])

  const handleContent = (pageName) => (
    <MotionBox
      id={`${pageName}-panel`}
      key={`${pageName}-panel`}
      variants={animateVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      position="fixed"
      top={0}
      right={0}
      height="calc(100dvh - 120px)"
      maxHeight="calc(100dvh - 120px)"
      display="flex"
      flexDirection="column"
      zIndex={1410}
      borderRadius="10px"
      overflow="hidden"
      marginBlock="60px"
      marginInline="10px"
      background={COLORS.charcoalGray}
      width="95% !important"
      maxWidth="450px"
      boxShadow="0 4px 10px rgba(0, 0, 0, 0.2) !important"
      sx={{
        '::-webkit-scrollbar': {
          display: 'none'
        },
        '-ms-overflow-style': 'none',
        'scrollbar-width': 'none'
      }}
    >
      <Box
        bg={COLORS.goldGradientRightToLeft}
        px="unset"
        py="5px"
        padding="0"
        height="48px"
        position="relative"
        flex="0 0 48px"
        onTouchStart={(e) => {
          touchStart = e?.targetTouches[0].clientX
        }}
        onTouchMove={(e) => {
          touchEnd = e?.targetTouches[0].clientX
        }}
        onTouchEnd={() => {
          if (touchStart - touchEnd < 45) {
            closeMessenger({ showParamIds: true })
          }
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="space-between"
          direction="row"
          height="48px"
        >
          <Box>
            <IconButton
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              outline="none"
              boxShadow="none"
              height="40px"
              width="40px"
              marginLeft="5px"
              icon={<SettingsIcon />}
              onClick={() => dispatch(setChatSectionPage('settings'))}
              display={pageName === 'chat-main' ? 'inline-flex' : 'none'}
            />

            <Box display={pageName.startsWith('chat-room-') ? 'auto' : 'none'}>
              <Avatar
                boxSize="35px"
                borderRadius="full"
                src={handleDirectChatAvatar()}
                flexShrink={0}
                marginLeft="20px"
                cursor="pointer"
                onClick={async () => {
                  const client = getMatrixClient()
                  const room = client?.getRoom(openRoomId)

                  if (room) {
                    await room?.loadMembersIfNeeded()

                    const members = room?.getJoinedMembers()
                    const foundMember = members.find((m) => {
                      let profileId = m.userId
                      profileId = getProfileIdFromMatrixId(profileId)

                      if (profileId !== activeProfile?.id) {
                        m.profileId = profileId
                        return true
                      }

                      return false
                    })

                    goToMarker(foundMember?.profileId)
                  }
                }}
              />

              <Text
                whiteSpace="nowrap"
                fontSize="22px"
                display="inline-flex"
                paddingLeft="15px"
              >
                { headerTitle(pageName) }
              </Text>
            </Box>
          </Box>

          <Text
            whiteSpace="nowrap"
            fontSize="24px"
            fontWeight={600}
            display={pageName.startsWith('chat-room-') ? 'none' : 'auto'}
            paddingLeft={pageName === 'chat-main' ? 0 : '50px'}
          >
            { headerTitle(pageName) }
          </Text>

          <Box>
            <IconButton
              id="chat-back-btn"
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              transform="rotate(180deg)"
              outline="none"
              boxShadow="none"
              height="40px"
              borderRadius="5px"
              marginRight="5px"
              icon={<ArrowIcon />}
              onClick={() => closeChatPanel()}
              css={{
                ':focus': {
                  outline: 'none',
                  boxShadow: 'none'
                }
              }}
            />
          </Box>
        </Stack>
      </Box>

      {
        pageName === 'chat-main'
        && (
          !hasRecoveryKey
          || needsToInputRecoveryKey
        )
        && (
          checkIfHasRecoveryKeyStatus === SUCCEEDED
          || checkIfHasRecoveryKeyStatus === REJECTED
        )
          ? (
            <Text
              background={COLORS.goldGradientRightToLeft}
              p="5px 10px"
              textAlign="center"
              cursor="pointer"
              onClick={() => dispatch(setChatSectionPage('settings'))}
            >
              {handleReminderMsg()}
            </Text>
          ) : ''
      }

      <Box
        flex="1"
        minH="0"
        width="100%"
        overflow="hidden"
      >
        { whatToShow(pageName) }
      </Box>

      {
        sharingToFriends
          ? (
            <Box
              zIndex="1000"
              flexDirection="column"
              padding="0"
              margin="0"
            >
              {
                copyBtnClicked
                  ? (
                    <Text
                      bg={COLORS.gold}
                      width="100%"
                      height="80px"
                      display="flex"
                      flexDir="column"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius="0 0 10px 10px"
                    >
                      <span>Thanks for sharing Connector!</span>
                      <span>Let's grow this community!</span>
                    </Text>
                  ) : (
                    <>
                      <Stack
                        width="100%"
                        display="flex"
                        flexDirection="row"
                        gap="0"
                        position="relative"
                      >
                        {
                          chosenFriends.length && !sendBtnClicked
                            ? (
                              <>
                                <Input
                                  bg={COLORS.gold}
                                  width="100%"
                                  placeholder="Add Message"
                                  border="solid 1px black"
                                  borderRight="none"
                                  borderRadius="0px"
                                  _focusVisible={{ borderColor: '' }}
                                  _hover={{ borderColor: '' }}
                                  value={msgInput}
                                  onChange={(e) => {
                                    setMsgInput(e.target.value)
                                    e.target.style.paddingRight = e.target.value ? '13%' : ''
                                  }}
                                  sx={{
                                    '::placeholder': {
                                      textAlign: 'center',
                                      color: 'black'
                                    }
                                  }}
                                />

                                <IconButton
                                  bg={COLORS.gold}
                                  outline="none"
                                  boxShadow="none"
                                  height="100%"
                                  width="10%"
                                  position="absolute"
                                  right="0"
                                  border="solid 1px black"
                                  borderRadius="0px"
                                  icon={<SendIcon />}
                                  _hover={{ background: COLORS.gold_hover }}
                                  onClick={() => {
                                    updateShareCount()

                                    dispatch(setMsgInputForBlogSharing(msgInput))

                                    const event = new CustomEvent('share-blog-to-friends')
                                    window.dispatchEvent(event)

                                    setSendBtnClicked(true)
                                    setTimeout(() => {
                                      setSendBtnClicked(false)
                                      setMsgInput('')
                                    }, 3000)
                                  }}
                                />
                              </>
                            ) : (
                              <Text
                                bg={COLORS.gray}
                                width="100%"
                                height="40px"
                                display="flex"
                                padding="0 5px"
                                alignItems="center"
                                justifyContent="center"
                                border="solid 1px black"
                                sx={{
                                  fontSize: sendBtnClicked ? 'clamp(10.5px, 1.5vw, 13px)' : ''
                                }}
                              >
                                {
                                  sendBtnClicked
                                    ? shareText
                                    : 'Choose contacts above'
                                }
                              </Text>
                            )
                        }
                      </Stack>

                      <Button
                        bg={chosenFriends.length ? COLORS.gray : COLORS.gold}
                        width="100%"
                        placeholder="Add Message"
                        borderRadius="0px"
                        fontWeight="400"
                        pointerEvents={chosenFriends.length ? 'none' : 'auto'}
                        onClick={() => {
                          updateShareCount()
                          navigator.clipboard.writeText(blogLinkToBeCopied)
                          setCopyBtnClicked(true)
                          setTimeout(() => setCopyBtnClicked(false), 3000)
                        }}
                        _hover={{ background: '' }}
                        _active={{ background: COLORS.gold }}
                      >
                        Copy link

                        <IconButton
                          bg="transparent"
                          outline="none"
                          boxShadow="none"
                          height="100%"
                          width="10%"
                          borderRadius="0px"
                          position="absolute"
                          right="0"
                          icon={<CopyIcon />}
                          _hover={{ background: '' }}
                        />
                      </Button>
                    </>
                  )
              }
            </Box>
          ) : ''
      }
    </MotionBox>
  )

  return (
    <AnimatePresence
      onExitComplete={() => {
        if (!chatSectionPage?.length) {
          closeMessenger({ fromAnimatePressence: true })
        }
      }}
    >
      {
        chatSectionPage?.length
        && (
          <>
            <Box
              zIndex={isAuth() ? 1399 : 1390}
              background="transparent"
              position="fixed"
              width="100%"
              height="50px"
              top={0}
              onClick={() => {
                dispatch(setCloseAllDrawers(true))
                setTimeout(() => dispatch(setCloseAllDrawers(false)), 850)
              }}
            />

            <Box
              zIndex={isAuth() ? 1399 : 1390}
              background="transparent"
              position="fixed"
              width="100%"
              height="50px"
              bottom={0}
              onClick={() => {
                dispatch(setCloseAllDrawers(true))
                setTimeout(() => dispatch(setCloseAllDrawers(false)), 850)
              }}
            />
          </>
        )
      }

      { chatSectionPage.map((pageName) => handleContent(pageName)) }
    </AnimatePresence>
  )
}
